import WebGLSketch from "../_app/cuchillo/3D/WebGLSketch";
import Image from "../_app/cuchillo/3D/Image";
import Plane from "../_app/cuchillo/3D/Plane";
import { GetBy } from "../_app/cuchillo/core/Element";
import Box from "./Box";
import { ControllerPage } from "../_app/cuchillo/pages/ControllerPage";
import Text3D from "../_app/cuchillo/3D/Text3D";

export default class BoxTeam extends Box {
  constructor(__dom) {
    super(__dom);

    const ter = GetBy.selector('[data-image-tertiary]', __dom)[0];
    if (ter) {
      const tertiary3D = new Image({
        dom: ter,
        size: {
          y: parseInt(ter.dataset.height),
          x: parseInt(ter.dataset.width)
        }
      });
      this.add(tertiary3D);
      this.items.push(tertiary3D);
    }

    const movie = GetBy.selector('[data-movie-poster]', __dom)[0];
    if (movie) {
      const movie3D = new Image({
        dom: movie,
        size: {
          y: parseInt(movie.dataset.height),
          x: parseInt(movie.dataset.width)
        }
      });

      this.add(movie3D);
      this.items.push(movie3D);
    }

    const plane = GetBy.selector('[data-bg]', __dom)[0];
    const plane3D = new Plane({
      dom: plane,
      size: {
        y: parseInt(plane.dataset.height),
        x: parseInt(plane.dataset.width)
      }
    });
    this.add(plane3D);
    this.items.push(plane3D);

    const linkedin = GetBy.selector('[data-link]', __dom)[0];
    if (linkedin) {
      const linkedin3D = new Image({
        dom: linkedin,
        size: {
          y: parseInt(linkedin.dataset.height),
          x: parseInt(linkedin.dataset.width)
        }
      });
      linkedin3D.mesh.userData.isClickable = true;
      linkedin3D.mesh.userData.link = linkedin.href;
      linkedin3D.mesh.userData.onClick = () => {
        window.open(linkedin3D.mesh.userData.link, '_blank').focus();
      };
      this.add(linkedin3D);
      this.items.push(linkedin3D);
      WebGLSketch.addInteractive(linkedin3D.mesh);
    }

    const name = GetBy.selector('[data-name]', __dom)[0];
    const name3D = new Text3D({ dom: name, text: name.dataset.name });
    this.add(name3D);
    this.items.push(name3D);

    const job = GetBy.selector('[data-job]', __dom)[0];
    const job3D = new Text3D({ dom: job, text: job.dataset.job });
    this.add(job3D);
    this.items.push(job3D);
  }
}
